module.exports = __webpack_public_path__ + "assets/valance-classic-scallop-selected.4d2ca6b6.svg";